import React, { useState } from "react";
import styles from './partList.module.css';
import {

  Paper,
  Typography,
  Box, Button,
  Divider, Grid,

} from "@mui/material";
import { Close, Payment } from "../../../Svg";
import { styled } from '@mui/material/styles';
import { fomateDate } from "../../../utils/fomateDate";
import { SignalCellularNull } from "@mui/icons-material";
import { approveEnquiryThunk, deleteProductFromScheduleThunk } from "../../../redux/schedulecartslice";
import { useDispatch } from "react-redux";
import DeleteModal from "../../reusable/deleteModal/DeleteModal";
import { useNavigate } from "react-router-dom";




const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  marginRight: theme.spacing(1),
  fontSize: '0.875rem',
  color: '#512DA8',
  fontSize: '14px',
  fontWeight: '600 !important',
  fontFamily: `'Public Sans', sans-serif`,
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));




const ScheduleList = ({ products, price, enqData, status, changeStatus, id,path }) => {

  const dispatch = useDispatch()
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null)
  const navigate = useNavigate()

  const deleteProductFromenq = () => {
    const data = {
      id,
      productId: selectedId
    }
    dispatch(deleteProductFromScheduleThunk(data))
    setIsModalOpen(false);
  }

  //delete modal open
  const handleDeleteClick = (id) => {
    setIsModalOpen(true);
    setSelectedId(id)
  };

  // console.log(products);


  return (
    <>
      <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px", marginTop: "26px" }}>
        <Box sx={{ p: 2, }} display="flex" justifyContent="space-between" >
          <Box display="flex" alignItems="center" >
            <Typography style={{ marginLeft: '10px', fontSize: '18px', fontWeight: "600", }}>
              {products?.length} Products
            </Typography>
            <Typography style={{ margin: '6px' }}>•</Typography>
            <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', color: '#4D4D4D' }}>
              Enquiry date: -: {fomateDate(enqData)}
            </Typography>
            <Typography style={{ margin: '6px' }}>•</Typography>
            <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "400", color: status === "NEW" ? '#727A90' : status === "APPROVED" ? '#1A9882' : '#E9BD21' }}>
              {status}
            </Typography>

          </Box>
          {status !== "APPROVED" ?
            <Box display="flex" alignItems="center" >
              <ActionButton onClick={() => navigate(`/schedule/editScheduleEnq/${id}`)}> Edit Enquiry</ActionButton>
            </Box>
            : null}
        </Box>
        <div className={styles.previewContainer}>
          <table className={styles.previewtable}>
            <thead>
              <tr>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Sl No</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}> Part #</th>
                <th className={styles.previewth}>Manufacture</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Total Quantity</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Schedule Qty</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Unit price</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {products?.map((item, index) => (
                <tr key={item.id} className={styles.previewstripedRow}>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{index + 1}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>
                    {item?.productDetails?.productOverview?.productNumber?.[0] || item?.productNumber}
                    {!item?.productId && (
                      <span style={{ display: 'inline-block', marginLeft: 6, padding: '1px 6px', borderRadius: 999, fontSize: 10, fontWeight: 600, background: '#FEF2F2', color: '#B91C1C', border: '1px solid #FECACA', whiteSpace: 'nowrap' }}>Not in catalog</span>
                    )}
                  </td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{item?.productDetails?.productOverview?.manufacturer?.[0]?.name || item?.manufacturerName || '-'}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{item?.totalQty}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{item?.quantity}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>₹{item?.unitPrice?.toFixed(4)}  </td>
                  {/* <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>${fomateDate(item?.deliveryDate)}  </td> */}
                  <td className={styles.previewtd}>
                    <div className={styles.closetd}>
                    ₹{(item?.totalQty * item?.unitPrice)?.toFixed(2)} {status !== 'APPROVED' && <span onClick={() => handleDeleteClick(item?.productId)}><Close /></span> }
                    </div>
                  </td>

                  <DeleteModal
                    isOpen={isModalOpen}
                    heading={'product'}
                    onClose={() => setIsModalOpen(false)}
                    onDelete={deleteProductFromenq}
                  />
                </tr>
              ))}
            </tbody>
          </table>



        </div>
      
      </Paper>
      {path === "scheduleOrderDetails" ? (
          null
        ) : (
      <Paper sx={{ padding: '20px 30px', mt: 2, boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
        <Box display="flex" justifyContent="space-between" alignItems='center' fontWeight="bold" >
          <Typography variant="h6" sx={{ fontSize: '18px', fontWeight: 600 }}>Grand Total: ₹{price?.total?.toFixed(2)}</Typography>
          {status !== 'APPROVED' ?
            <ActionButton sx={{ background: '#512DA8', color: '#fff' }} onClick={() => dispatch(approveEnquiryThunk(id))}>Approve & submit</ActionButton>
            : null}
        </Box>
      </Paper>
      )}
    </>
  );
};

export default ScheduleList;
